import { render, staticRenderFns } from "./GoLateRequests.vue?vue&type=template&id=5ec9fb21&scoped=true"
import script from "./GoLateRequests.vue?vue&type=script&lang=js"
export * from "./GoLateRequests.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/css/layout/Request.css?vue&type=style&index=0&id=5ec9fb21&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec9fb21",
  null
  
)

export default component.exports